import React, { useState }                from 'react';
import { useDispatch, useSelector }       from 'react-redux';

import SelectIco                          from 'images/pu/shared/arrow_triangle.svg';

import Accessory                          from './components/Accessory';

import { selectAccessoryProducts }          from './selectors/selectors';

import { 
  changeAccessoryQuantity,
  changeAccessorySelected,
  changeAccessoryVariant,
} from './accessoriesSlice';

const Accessories = () => {
  const dispatch = useDispatch();

  const {
    paste_products, 
    other_products,
  } = useSelector(selectAccessoryProducts);

  const onChangeQuantity = (index, quantity) => {
    dispatch(changeAccessoryQuantity({ index, quantity }));
  }

  const onChangeVariant = (index, variant) => {
    dispatch(changeAccessoryVariant({index, variant}))
  }

  const onSelect = (index) => {
    dispatch(changeAccessorySelected({ index }));
  }

  return (
    <>
      <div className='d-flex align-items-center select-paragraph spacing-1'>
        <img src={SelectIco} alt="Select Solder Paste Product" className='select-icon'/>
        <h6 className="select-title mb-0">&nbsp;To select an item please click the checkbox and enter a quantity.</h6>
      </div>
      <div className="row">
        {paste_products.map((accessory, idx) => (
          <div key={`paste-product-${idx}`} className='col-12 col-md-3'>
            <Accessory
              accessory={accessory}
              accessoryClassName="paste-item"
              onChangeQuantity={onChangeQuantity}
              onChangeVariant={onChangeVariant}
              onSelect={onSelect}/>
          </div>
        ))}
      </div>
      <div className='d-flex align-items-center select-paragraph spacing-2'>
        <img src={SelectIco} alt="Select Other Product" className='select-icon'/>
        <h6 className="select-title mb-0">&nbsp;To select an item please click the checkbox and enter a quantity.</h6>
      </div>
      <div className="row">
        {other_products.map((accessory, idx) => (
          <div key={`other-product-${idx}`} className='col-12 col-md-3'>
            <Accessory
              accessory={accessory}
              accessoryClassName="other-item"
              onChangeQuantity={onChangeQuantity}
              onChangeVariant={onChangeVariant}
              onSelect={onSelect}/>
          </div>
        ))}
      </div>
    </>
  )
}

export default Accessories;